
import './EcosystemCard.css'

interface EcosystemCardProps {
  name: string
  url: string
  description: string
  icon: string
  featured?: boolean
}

export default function EcosystemCard({ 
  name, 
  url, 
  description, 
  icon, 
  featured = false 
}: EcosystemCardProps) {
  return (
    <a 
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`ecosystem-card-component ${featured ? 'featured' : ''}`}
    >
      <span className="eco-card-icon">{icon}</span>
      <h4 className="eco-card-title">{name}</h4>
      <p className="eco-card-desc">{description}</p>
    </a>
  )
}
